import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { openGlobalPopup } from "../../redux/action";
import CommonSearchBox from "../SearchBox/CommomSearchBox";
import ConfirmBox from "../Popup/ConfirmBox";
import EmptyScreen from "../common/EmptyScreen";
import { Eye, Edit2, Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";

function AddonList({ addonGroups = [], onEdit, onDelete }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [previewItems, setPreviewItems] = useState(null);

  const filteredGroups = (addonGroups || []).filter((g) =>
    g.groupName.toLowerCase().includes(search.toLowerCase())
  );

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    dispatch(openGlobalPopup("confirm-box"));
  };

  return (
    <div className="table-container">

       <h3 style={{ padding: "0px 0px 0px 10px" }}>{t("Add-ons")} ({filteredGroups.length})</h3>
          <CommonSearchBox
            placeholder="Search add-on group by name..."
            search={search}
            setSearch={setSearch}
          />

      {filteredGroups.length === 0 ? (
        <EmptyScreen message="No Add-on Groups found. Please add one." />
      ) : (
        <>
         
          <div className="table-wrapper">
            <table className="table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Select Quantity</th>
                  <th>Foods / Items</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredGroups.map((group) => (
                  <tr key={group.addonGroupId}>
                    <td><strong>{group.groupName}</strong></td>
                    <td>{group.maxSelection}</td>
                    <td>
                      <button
                        type="button"
                        className="view-link app-back-btn"
                        onClick={() => setPreviewItems(previewItems?.addonGroupId === group.addonGroupId ? null : group)}
                        style={{ border: "none", background: "transparent", cursor: "pointer", display: "inline-flex", alignItems: "center", gap: "6px" }}
                      >
                        <Eye size={16} color="var(--ui-warning-text)" />
                        View items ({group.addonItems?.length || 0})
                      </button>

                      {/* Small inline preview dropdown */}
                      {previewItems?.addonGroupId === group.addonGroupId && (
                        <div style={previewBoxStyle}>
                          {group.addonItems?.map((item) => (
                            <span key={item.addonItemId} style={itemBadgeStyle}>
                              {item.itemName} (₹{item.price})
                            </span>
                          ))}
                        </div>
                      )}
                    </td>
                    <td>
                      <span
                        className="edit-icon link-btn"
                        title="Edit"
                        onClick={() => onEdit(group)}
                        style={{ marginRight: "12px", cursor: "pointer" }}
                      >
                        ✎
                      </span>
                      <span
                        className="delete-icon link-btn danger"
                        title="Delete"
                        onClick={() => handleDeleteClick(group.addonGroupId)}
                        style={{ cursor: "pointer" }}
                      >
                        ✖
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      <ConfirmBox
        variant="delete"
        title={"Are you sure you want to delete this Add-on Group?"}
        onConfirm={() => {
          if (deleteId) onDelete(deleteId);
        }}
        onCancel={() => setDeleteId("")}
      />
    </div>
  );
}

const previewBoxStyle = {
  marginTop: "8px",
  display: "flex",
  flexWrap: "wrap",
  gap: "6px",
  backgroundColor: "var(--ui-surface-muted)",
  padding: "8px",
  borderRadius: "6px"
};

const itemBadgeStyle = {
  backgroundColor: "var(--ui-surface)",
  border: "1px solid var(--ui-border)",
  padding: "3px 8px",
  borderRadius: "12px",
  fontSize: "12px",
  color: "#374151"
};

export default AddonList;
